import { all } from 'redux-saga/effects'
import watchProgramRequest from './watchProgramRequest'
import { watchUpdateMovieItem } from './WatchUpdateMovieItem'
import watchAddDisplaySelection from './watchAddDisplaySelection'
import watchDeleteDisplaySelection from './watchDeleteDisplaySelection'
import watchReorderProgramItem from './watchReorderProgramItem'
import { watchUpdateMovieOrder } from './watchUpdateMoviesOrder'
import { watchUpdateSelectionsDisplayOrder } from './watchUpdateSelectionsDisplayOrder'
import { watchAddAd } from './watchUpdateAds'
import { watchAddWeischerAd } from './watchUpdateWeischerAds'
import { watchUpdateProgram, watchDeleteProgram } from './watchChangeProgram'
import { watchAddHighlight } from './watchUpdateHighlight'
import { watchAddAdvertisement } from './watchAddAdvertisement'
import watchDeleteAdvertisement from './watchDeleteAdvertisement'
import { watchBrandMovieMappingsUpdate } from './watchBrandMovieMappingsUpdate'

export default function* programSaga() {
    yield all([
        watchProgramRequest(),
        watchAddDisplaySelection(), //ToDo: Add & Delete als entweder oder
        watchDeleteDisplaySelection(),
        watchUpdateSelectionsDisplayOrder(),
        watchAddAd(),
        watchAddWeischerAd(),
        watchAddHighlight(),
        watchAddAdvertisement(),
        watchDeleteAdvertisement(),
        watchReorderProgramItem(),
        watchUpdateMovieItem(),
        watchUpdateMovieOrder(),
        watchUpdateProgram(),
        watchDeleteProgram(),
        watchBrandMovieMappingsUpdate()
    ])
}